<script>
export default {
  name: "radicarEntesdeControl",
  data() {
    return {
      srcFrame: `${this.$httpClient.defaults.bpms}/sysworkflow/en/famisanar_skin/login/login`,
    };
  },
  methods: {
    redirectToRadicar() {
      window.open(this.srcFrame, "_blank");
      this.$router.go(-1);
    },
  },
  mounted() {
    this.redirectToRadicar();
  },
};
</script>
